define('models/recurring_product',['require','backbone','models/product'],function(require){

    var Backbone = require('backbone');

    var ProductModel = require('models/product');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'recurring-licenses/' + this.id + '/' ) :
                ( App.Config.apiBase + 'recurring-licenses/' );
        },

        defaults: function () {
            return {
                id: null,
                product: new ProductModel().attributes,
                start_time: '',
                end_time: '',
                is_valid: false,
                is_activated: false,
                owner_details: null,
                customer_details: null,
                is_owner: false,
            };
        }
    });
});
